// Random, per-browser identifier used only as a "known device" signal.
// Not a fingerprint: it is generated locally, contains no browser data, and is HMAC-hashed server-side.
// Clearing site data creates a new one (the user then simply looks like a new device).
const KEY = "empivoDeviceId";
const VALID = /^[A-Za-z0-9_-]{16,64}$/;

function generate() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const b = new Uint8Array(16);
  window.crypto.getRandomValues(b);
  return Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
}

export const getDeviceId = () => {
  try {
    let id = localStorage.getItem(KEY);
    if (!VALID.test(id || "")) {
      id = generate();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch (e) {
    return ""; // storage blocked: backend treats the device signal as NOT_PROVIDED (neutral)
  }
};